export default {"src":"/_next/static/media/docs-post-sm.3b1286f1.svg","height":283,"width":375};